import { render, staticRenderFns } from "./bgdialog.vue?vue&type=template&id=25f137b2&scoped=true&"
import script from "./bgdialog.vue?vue&type=script&lang=js&"
export * from "./bgdialog.vue?vue&type=script&lang=js&"
import style0 from "./bgdialog.vue?vue&type=style&index=0&id=25f137b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f137b2",
  null
  
)

export default component.exports